<template>
  <div>
    <div class="backBox">
      <img class="pointer" @click="toGiftList" src="@/assets/thdImg/pages/back.svg" alt=""/>
      <span class="backBox_name">积分商城装修</span>
    </div>
    <div class="container">
      <div class="integral">
        <div class="decor-content" v-if="!isHasSave">
          <span class="content-title"></span>&nbsp;
          <span class="content-tips">积分商城推广</span>
          <div class="content-form">
            <el-form :model="formSave" label-width="124px">
              <el-form-item label="活动背景图：" required>
                <div class="flex-style">
                  <el-upload style="display: flex;align-items: center;" action="/jd-hd-web/image/upload" ref="upload"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                    :show-file-list="false" accept=".png, .jpg">
                    <el-button size="mideal" class="returnBtn">自定义上传</el-button>
                  </el-upload>
                  <span class="reset" @click="formSave.awardImageUrl = 'https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png'">重置</span>
                  <span class="size-style">
                    尺寸建议：750*602px；支持格式：jpg，png
                  </span>
                </div>
              </el-form-item>
              <el-form-item label="兑换列表样式：">
                <el-radio v-model="formSave.listStyle" :label="1" @change="handleColor">列表模式</el-radio>
                <el-radio v-model="formSave.listStyle" :label="2" @change="handleColor">网格模式</el-radio>
              </el-form-item>
              <el-form-item label="是否显示库存：">
                <el-radio v-model="formSave.stockIsShow" :label="false">不显示</el-radio>
                <el-radio v-model="formSave.stockIsShow" :label="true">显示</el-radio>
              </el-form-item>
              <el-form-item label="是否显示面值：">
                <el-radio v-model="formSave.awardValueIsShow" :label="false">不显示</el-radio>
                <el-radio v-model="formSave.awardValueIsShow" :label="true">显示（开启后C端兑换列表页显示奖品价值）</el-radio>
              </el-form-item>
              <el-form-item label="是否显示倒计时：">
                <el-radio v-model="formSave.countdownIsShow" :label="false">不显示</el-radio>
                <el-radio v-model="formSave.countdownIsShow" :label="true">显示（开启后C端兑换列表页显示奖品价值）</el-radio>
              </el-form-item>
              <el-form-item label="积分价格题色：" required>
                <div class="color-item">
                  <el-color-picker v-model="formSave.pointPriceTextColor"></el-color-picker>
                  <span class="reset" @click="formSave.pointPriceTextColor = formSave.listStyle ==1 ? '#B76733' : '#E8D291'">重置</span>
                </div>
              </el-form-item>
              <el-form-item label="兑换按钮设置：" required>
                <div class="btn-setting">
                  <div class="color-item">
                    按钮背景色：
                    <el-color-picker v-model="formSave.buttonBgColor"></el-color-picker>
                    <span class="reset" @click="formSave.buttonBgColor = '#1E1E1F'">重置</span>
                  </div>
                  <div class="color-item" style="margin-top: 20px;">
                    按钮文字色：
                    <el-color-picker v-model="formSave.buttonTextColor"></el-color-picker>
                    <span class="reset" @click="formSave.buttonTextColor = '#ffffff'">重置</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="自定义广告位：">
                <div class="ad-setting">
                  <el-form-item label="广告标题：" label-width="100px">
                    <el-input style="width: 320px;" v-model="formSave.adTitle" placeholder="请输入标题" maxlength="10" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="上传图片：" label-width="100px">
                    <div class="flex-style">
                      <el-upload style="display: flex;align-items: center;margin-right: 16px" action="/jd-hd-web/image/upload"
                        :before-upload="beforeUpload1"
                        :on-success="handleSuccess1"
                        :show-file-list="false" accept=".png, .jpg">
                        <el-button size="mideal" class="returnBtn">自定义上传</el-button>
                      </el-upload>
                      <span class="size-style">
                        尺寸建议：750*320px；支持格式：jpg，png
                      </span>
                    </div>
                    <div class="common-flex">
                      <div v-for="(url,index) in adPicList" :key="index" class="img-style">
                        <img :src="url" alt class="url-style">
                        <img src="@/assets/images/preview/close.png" alt="" class="close-style" @click="deleteHasSelect(index)">
                      </div>
                    </div>
                  </el-form-item >
                  <el-form-item label="跳转链接：" label-width="100px">
                    <el-input style="width: 320px;" v-model="formSave.adLink" placeholder="请输入http://开头的链接"></el-input>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="小程序店铺信息：" label-width="150px">
              <el-radio-group v-model="formSave.shopNameType">
                  <el-radio :label="0">统一显示配置店铺</el-radio>
                  <el-radio :label="2">不显示店铺信息</el-radio>
              </el-radio-group>
            </el-form-item>
            </el-form>
            <div class="footer">
              <el-button type="primary" @click="savePointSetting">保存设置</el-button>
              <el-button @click="handleReset">重置</el-button>
              <el-button style="width: auto;" @click="toGiftList">去添加积分兑换活动</el-button>
            </div>
          </div>
        </div>
        <div class="extension-content" v-else>
          <span class="content-title"></span>&nbsp;
          <span class="content-tips">积分商城推广</span>
          <div class="tips">
            请用手机京东扫描下面二维码查看您店铺的活动详情
          </div>
          <div class="qrcode-style">
            <qrcode-vue
              v-if="qrcodeVue.value"
              class="qrcode"
              :id="'qrcode'"
              :ref="'qrcode'"
              :size="qrcodeVue.size"
              :value="qrcodeVue.value"
              :bgColor="qrcodeVue.bgColor"
              :fgColor="qrcodeVue.fgColor"
            >
            </qrcode-vue>
          </div>
          <div>链接地址：(手机京东店铺中活动详情链接地址)</div>
          <div class="copy-link">
            <el-tooltip class="item" effect="dark" :content="qrcodeVue.value" placement="top-start">
              <div style="max-width: 400px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{qrcodeVue.value}}</div>
            </el-tooltip>
            <div>
              <span class="reset1" v-clipboard:copy="qrcodeVue.value" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</span>
              <span class="reset1" @click="handleSrcImg">下载</span>
            </div>
          </div>
          <div class="footer-btn">
            <el-button  style="width: auto;"  type="primary" @click="isHasSave = false" >装修积分商城</el-button>
            <el-button style="width: auto;" @click="toGiftList">去添加积分兑换活动</el-button>
          </div>
        </div>
      </div>
      <div class="decoration-right">
          <span class="title"></span>&nbsp;
          <span class="right-tips">页面效果预览</span>
          <div style="margin-top: 20px;">
            <phoneShow :formConfig="formSave" :list="pointExchangeActList"></phoneShow>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import qrcodeVue from "qrcode-vue";
import phoneShow from "./phoneShow.vue"
import {exchangeActivityList,saveEchange,getDecorationInfoDetail} from "@/api/paradiseAndTaskCommonController.js";
export default {
   name: '',
   components: {
    qrcodeVue,
    phoneShow
   },
   props: {
     
   },
   data() {
     return {
      adPicList: [],
      templateId: "",
      // 限制图片上传格式
      extensions:[".jpg", ".png"],
      isHasSave: false,
      formSave: {
        awardImageUrl: "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png",
        listStyle: 1,
        stockIsShow: false,
        awardValueIsShow: false,
        countdownIsShow: false,
        moreActivityIsShow: false,
        pointPriceTextColor: '#B76733',
        buttonBgColor:'#1E1E1F',
        buttonTextColor:'#ffffff',
        adTitle: "",
        adPic: "",
        adLink: "",
        shopNameType: 0,
      },
      cacheForm: {
        awardImageUrl: "https://yunqi-hd-public.tos-cn-beijing.volces.com/image/pointExchangeBg.png",
        listStyle: 1,
        stockIsShow: false,
        awardValueIsShow: false,
        countdownIsShow: false,
        moreActivityIsShow: false,
        pointPriceTextColor: '#B76733',
        buttonBgColor:'#1E1E1F',
        buttonTextColor:'#ffffff',
        adTitle: "",
        adPic: "",
        adLink: "",
        shopNameType: 0,
      },
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      pointExchangeActList: []
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
    this.queryTemplate()
   },
   methods: {
    handleReset() {
      this.formSave = JSON.parse(JSON.stringify(this.cacheForm))
      this.adPicList = []
    },
    deleteHasSelect(index) {
      this.adPicList.splice(index,1)
      this.formSave.adPic = ""
    },
    toGiftList() {
      this.$emit("returnStep");
    },
    queryTemplate() {
        getDecorationInfoDetail().then((res)=>{
          if(res.code==1) {
            if(res.data&&res.data.id > 0){
              this.templateId = res.data.id
              this.formSave = JSON.parse(res.data.detailInfo)
              this.$set(this.formSave,"shopNameType", this.formSave.shopNameType || 0);
              this.adPicList = this.formSave.adPic ? [this.formSave.adPic] : []
              this.isHasSave = true
              let xcxUrl = this.$commonUrl(); // 正式
              let params1 = `venderId%3D${ res.data.venderId}`;
              this.qrcodeVue.value = xcxUrl + "pages/pointExchange/exchangeList/exchangeList.html%3f" + params1;
            }else{
              this.qrcodeVue.value = ''
              this.templateId = ''
              this.formSave = JSON.parse(JSON.stringify(this.cacheForm))
              this.isHasSave = false
            }
          }
          let params = {
            current: 1,
            size: 100,
            isDisplay: 1
          }
          exchangeActivityList(params).then((res)=>{
            if(res.code==1) {
              this.pointExchangeActList = res.data.records
            }
          })
        })
    },
    toGiftList() {
      this.$emit("returnStep");
    },
    savePointSetting() {
      if(!this.formSave.awardImageUrl||!this.formSave.buttonBgColor||!this.formSave.buttonTextColor){
        this.$message.warning('请先完善页面信息~')
        return
      }
      let formData = {
        detailInfo: JSON.stringify(this.formSave)
      }
      saveEchange(formData).then((res)=>{
        if(res.code==1) {
          this.isHasSave = true
          this.queryTemplate()
          this.$message.success(res.message)
        }else {
          this.$message.error(res.message)
        }
      }).catch((err)=>{
        this.$message.error(res.message)
      })
    },
    handleColor(val) {
      if(val==1) {
        this.formSave.pointPriceTextColor = "#B76733"
      } else {
        this.formSave.pointPriceTextColor = "#E8D291"
      }
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    handleSuccess(res, file) {
      if(res && res.code == 1) {
        this.$message.success('上传图片成功')
        this.formSave.awardImageUrl = res.data
      }
    },
    handleSuccess1(res, file) {
      if(res && res.code == 1) {
        this.$message.success('上传图片成功')
        this.formSave.adPic = res.data
        this.adPicList = [this.formSave.adPic]
      }
    },
    beforeUpload(file) {
      let fileExtensions = this.extensions.some(ext => file.name.toLowerCase().endsWith(ext))
      if (!fileExtensions) {
        this.$message.error('图片格式错误');
        this.$refs.upload.clearFiles();
        return
      }
    },
    beforeUpload1(file) {
      let fileExtensions = this.extensions.some(ext => file.name.toLowerCase().endsWith(ext))
      if (!fileExtensions) {
        this.$message.error('图片格式错误');
        this.$refs.upload1.clearFiles();
        return
      }
    },
   },
};
</script>
<style lang='scss' scoped>
.container {
  display: flex;
  flex-wrap: nowrap;
  font-family: PingFang SC, PingFang SC;
  background: #fff;
  .integral {
    min-width: 730px;
    width: calc(100% - 432px);
    height: calc(100vh - 100px);
    margin-right: 16px;
    // padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    overflow-y: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar { width: 0 !important };
    -ms-overflow-style: none;
    .decor-content {
      margin-top: 20px;
      .content-form {
        margin-top: 26px;
        .btn-setting {
          width: 500px;
          background: #F8F9FC;
          padding: 22px 16px;
        }
        .ad-setting {
          width: 500px;
          background: #F8F9FC;
          padding: 22px 0;
          .common-flex {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            .img-style  {
              position: relative;
              width: 100px;
              height: 100px;
              margin-top: 16px;
              margin-right: 20px;
              border-radius: 4px;
              .url-style {
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }
              .close-style {
                cursor: pointer;
                width: 24px;
                height: 24px;
                position: absolute;
                top: 0;
                right: 0;
              }
            }
            .img-style:not(:first-child) {
              margin-left: 20px;
            }
          }
        }
        .color-item {
          display: flex;
          align-items: center;
          color: #666666;
          font-size: 14px;
        }
        .size-style {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          white-space: nowrap;
        }
        .flex-style {
          display: flex;
        }
      }
    }
    .extension-content {
      margin-top: 20px;
      .tips {
        margin: 20px 0;
      }
      .qrcode-style {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
      }
      .copy-link {
        margin-top: 20px;
        display: flex;
        align-items: center;
      }
      .footer-btn {
        margin-top: 20px;
      }
    }
  }
  .decoration-right {
    width: 416px;
    background: #ffffff;
    border-radius: 16px;
    height: calc(100vh - 100px);
    padding: 20px;
    overflow-y: auto;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: #7b61ff;
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .right-tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
  .content-title {
    display: inline-block;
    width: 2px;
    height: 14px;
    background: #7b61ff;
    opacity: 1;
    border-radius: 3px;
    vertical-align: middle;
  }
  .content-tips {
    font-size: 16px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
    vertical-align: middle;
  }
  .returnBtn {
    border-radius: 4px;
    width: auto;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #7b61ff;
    background: rgba(123, 97, 255, 0.1);
    border: 1px solid #7b61ff;
    &:hover {
      color: #fff;
      background: #7b61ff;
    }
  }
  .reset {
    margin: 0 16px;
    color: #7b61ff;
    cursor: pointer;
    font-size: 14px;
  }
  .reset1 {
    margin: 0 8px;
    color: #7b61ff;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>